export default "__VITE_PUBLIC_ASSET__15e7f46f__"